import React from 'react';
import PropTypes from 'prop-types';
import './styles/style.scss';

const Pre = props => <pre className="c-vi-pre">{props.children}</pre>;

Pre.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Pre;



// WEBPACK FOOTER //
// ./src/app/notifications/shared/visualIdentity/Pre.jsx